import { render, staticRenderFns } from "./EditCardHolder.vue?vue&type=template&id=da638c64"
import script from "./EditCardHolder.vue?vue&type=script&lang=js"
export * from "./EditCardHolder.vue?vue&type=script&lang=js"
import style0 from "./EditCardHolder.vue?vue&type=style&index=0&id=da638c64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports